import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Victory3";

const Victory3 = () => {
  const projectId = 45;
  const title = "Victory Phase 3";

  const mapConfig = {
    minZoom: 10,
    zoom: 12,
    bounds: [
      [61.79, 18.15],
      [61.62, 18.64],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      // Links disabled in original component
      viewProjectLink={null}
      fillOfferLink={null}
    />
  );
};

export default Victory3;
